import { useEffect } from "react";
import { useLocation, useRoute } from "wouter";

export default function OrderDetail() {
  const [, params] = useRoute("/orders/:id");
  const [, navigate] = useLocation();
  const id = params?.id;
  useEffect(() => {
    // [items.purchase-workspace](../../../docs/product/items.md#items-purchase-workspace): keep historical order links pointing to purchase management in Contracts.
    if (id) navigate(`/contracts?order=${encodeURIComponent(id)}`, { replace: true });
  }, [id, navigate]);
  return <div className="container-x py-20 text-center text-mut">Opening purchase agreement…</div>;
}
